import clsx from "clsx";

interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
	label: string;
}

export default function label({
	htmlFor,
	label,
	className = "",
	...props
}: Props) {
	return (
		<label
			data-testid="test-label"
			htmlFor={htmlFor}
			className={clsx("form__label", className)}
			{...props}
		>
			{label}
		</label>
	);
}
